export default __webpack_public_path__ + "static/media/pvilla2-4.287239c3.webp";